<template>
  <div>
    <loader v-if="loader"/>
    <b-row>
      <b-col class="text-muted">
        <b-row>
          <b-col
            :xl="input.columns"
            :md="inputsWidth"
            v-for="(input, index) in mainInputs"
            :key="`${index}${input.name}`">
            <b-input-group class="flex-column">
              <label class="d-block" :for="input.id">{{ input.label }}</label>
              <multiselect
                v-if="input.type === 'select'"
                v-model="sortingObject[input.name]"
                :id="input.name"
                label="label"
                track-by="value"
                :placeholder="input.placeholder"
                :options="input.options"
                :searchable="false"
                :close-on-select="true"
                @select="value => {debounceSorting(input.name, value)}"
                @search-change="query => {debounceGetSelectOptions(input.options_url, input.name, input.sorting_field, query)}"
                select-label=""
                selected-label=""
                deselect-label="">

                <template #caret="props" >
                  <div class="multiselect__select_caret"
                       :class="sortingTypeObject[input.name] && sortingTypeObject[input.name].sortType === 'desc' ? 'descending' : 'ascending'"
                       @mousedown.prevent.stop="toggle(input.name)">
                  </div>
                </template>

                <template slot="noResult">
                  {{$t('global.no_results')}}
                </template>
              </multiselect>

            </b-input-group>
          </b-col>

          <b-col
                  :xl="input.columns"
                  :md="inputsWidth"
                  v-for="(input, index) in selects"
                  :key="`${index}${input.name}`"
                  v-if="selectOptions[input.name]"
          >

            <label
                    class="d-block"
                    v-if="input.label"
                    :for="input.id">{{ input.label }}</label>

            <multiselect
                    v-model="sortingObject[input.name]"
                    :id="input.name"
                    label="label"
                    track-by="value"
                    :placeholder="input.placeholder"
                    :options="selectOptions[input.name]"
                    :searchable="false"
                    :close-on-select="true"
                    @select="value => {sorting(input.name, value)}"
                    @search-change="query => {debounceGetSelectOptions(input.options_url, input.name, input.sorting_field, query)}"
                    select-label=""
                    selected-label=""
                    deselect-label="">

              <template #caret="props">
                <div class="multiselect__select_caret"
                     @mousedown.prevent.stop="toggle(input.name)">

                </div>
              </template>

              <template slot="noResult">
                {{$t('global.no_results')}}
              </template>
            </multiselect>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {filter, forEach, isObject, debounce, isEmpty} from 'lodash';

  export default {
    props: {
      inputs: {
        type: Array,
        required: true
      },
      inputsWidth: {
        type: Number,
        default: 12
      },
      sorts: {
        type: Object,
        default: {}
      },
      forceUpdate: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loader: false,
        sortingObject: {},
        sortingObjectMutated: {},
        sortingTypeObject: [],
        selectOptions: {},
        debounceSorting: () => {
        },
        debounceGetSelectOptions: () => {
        }
      }
    },
    components: {},
    mounted() {
      this.sortingObject = this.sorts;
      this.$forceUpdate();
      this.loader = this.loading;
      this.debounceSorting = debounce(this.sorting, 500);
      this.debounceGetSelectOptions = debounce(this.getSelectOptions, 500);
      this.inputs.forEach(input => {
        this.sortingTypeObject[input.name] = {};
        if(isEmpty(this.sortingTypeObject[input.name].sortType)) {
          this.sortingTypeObject[input.name].sortType = input.sortType ? input.sortType : 'desc';
        }
        this.sortingTypeObject[input.name].orderFieldName = input.orderFieldName || `${input.name}By`;
      });
    },
    computed: {
      mainInputs() {
        return filter(this.inputs, input => input.main);
      },
      secondaryInputs() {
        return filter(this.inputs, input => !input.main)
      },
      selects() {
        let selects = filter(this.secondaryInputs, input => input.type === 'select');

        forEach(selects, select => {
          if (!!select.options_url) {
            this.getSelectOptions(select.options_url, select.name)
          } else {
            this.selectOptions[select.name] = select.options;
          }
        });
        return selects
      },
    },
    methods: {
      toggle (fieldName) {
        this.sortingTypeObject[fieldName].sortType = this.sortingTypeObject[fieldName].sortType === 'desc'? 'asc' : 'desc';
        this.emitParams(fieldName, this.sortingObject[fieldName].value, true);
      },

      sorting(field, value) {
        if (isObject(field)) {
          value = field.value;
          field = field.field;
        }

        if (isObject(value)) {
          if (Array.isArray(value)) {
            value = value.map(item => {
              return item.value
            })
          } else if (value.hasOwnProperty('value')) {
            value = value.value;
          }
        }
        this.emitParams(field, value)

      },

      emitParams(field, value, force = false) {
        let params = {};
        if (value === '' && !force) {
          delete this.sortingObject[field];
          delete this.sortingObjectMutated[field];
        } else {
          this.sortingObjectMutated[field] = value;
          this.sortingObjectMutated[`${this.sortingTypeObject[field].orderFieldName}`] = this.sortingTypeObject[field].sortType ? this.sortingTypeObject[field].sortType : 'desc';
        }
        params = this.sortingObjectMutated;

        this.$emit('sorting', params);
        this.forceUpdateManually();
      },

      forceUpdateManually() {
        if(this.forceUpdate) {
          this.$forceUpdate();
        }
      },

      getSelectOptions(url, name, field = null, value = null) {
        const params = {filter: {}};
        if (value) {
          params.filter[field] = value
        }
        try {
          this.loader = true;
          this.getData(url, {params}).then(({data}) => {
            if (data && data.items) {
              this.selectOptions[name] = data.items.map(option => {
                if (option.name && option.id) {
                  return {
                    label: option.name,
                    value: option.id
                  }
                } else if (option.slug && option.title) {
                  return {
                    label: option.title,
                    value: option.slug
                  }
                } else if (option.slug && !option.title) {
                  return {
                    label: option.slug,
                    value: option.slug
                  }
                } else if (option.title) {
                  return {
                    label: option.title,
                    value: option.title
                  }
                } else if (option.key) {
                  return {
                    label: option.key,
                    value: option.id
                  }
                }
              });
              this.$forceUpdate();
            }
          })

        } catch (e) {
          console.log(e)
        } finally {
          this.loader = false;
        }
      },
    },
    watch: {
      loading(value) {
        this.loader = value
      },
      sorts(val) {
        this.sortingObject = val;
      }
    }
  }

</script>
<style lang="scss" scoped>
  .multiselect__select_caret {
    position: absolute;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
    transition: transform .2s ease;
    line-height: 16px;
    box-sizing: border-box;
    display: block;
    margin: 0;
    text-decoration: none;
    cursor: pointer;

    &.ascending {
      transform: rotate(180deg);
    }
    &:before {
      position: relative;
      right: 0;
      top: 65%;
      color: #999;
      margin-top: 4px;
      border-color: #999 transparent transparent;
      border-style: solid;
      border-width: 5px 5px 0;
      content: "";
    }
  }
</style>